import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.replace";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import service from '../services/service';
import cookie from '@tencent/vft-common/cookie';
export default {
  name: 'my_record',
  props: ['money'],
  data: function data() {
    return {
      eggTypeText: ['新春福蛋', 'yoo福蛋', '小捣蛋', 'yoo小捣蛋', '商家蛋', '明星福蛋'],
      index: 0,
      msgList: [],
      myRecord: [],
      vuid: '',
      zhanji: {
        pageIndex: -1,
        pageSize: 20,
        allLoaded: true
      },
      jilu: {
        pageIndex: -1,
        pageSize: 20,
        allLoaded: true
      }
    };
  },
  computed: _objectSpread({}, mapState(['isLogin']), {
    list: function list() {
      return this.index ? this.msgList : this.myRecord.map(function (item) {
        if (item.myGoodsDouble) {
          item.myGoodsDouble = 0;
          item.myGoodsName = item.myGoodsName.replace(/(\D*)([\d|.]+)(.*)(现金)/g, function ($0, $1, $2, $3, $4) {
            item.myGoodsDouble = 1;
            return "".concat($1).concat($2).concat($3, "<del class=\"before\">").concat($2 / 2).concat($3, "</del>").concat($4);
          });
        }

        return item;
      });
    },
    allLoaded: function allLoaded() {
      return this.index ? this.jilu.allLoaded : this.zhanji.allLoaded;
    }
  }),
  methods: {
    eggIconClass: function eggIconClass(info) {
      var types = ['fu', 'yoo', 'dao', 'yoo_dao', '', 'yoo'];
      return types[info.myEggType] || '';
    },
    clickHandler: function clickHandler() {
      if (!this.isLogin) {
        this._openLogin();

        return;
      }

      this.rootOpenUrl('//film.qq.com/weixin/v3/asset/index.html#award');
    },
    tabSwitch: function tabSwitch(index) {
      this.index = index;
    },
    loadMore: function loadMore() {
      this.index ? this.getMsg() : this.getMyRecord();
    },
    refresh: function refresh() {
      this.index ? this.getMsg(true) : this.getMyRecord(true);
    },
    getMyRecord: function () {
      var _getMyRecord = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(isRefresh) {
        var reRes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isRefresh) {
                  this.zhanji.pageIndex = 0;
                } else {
                  this.zhanji.pageIndex++;
                }

                _context.next = 3;
                return service.getMyRecord({
                  pageIndex: this.zhanji.pageIndex,
                  pageSize: this.zhanji.pageSize
                });

              case 3:
                reRes = _context.sent;

                if (reRes.ret === 0) {
                  if (isRefresh) {
                    this.myRecord = reRes.list || [];
                  } else {
                    this.myRecord = this.myRecord.concat(reRes.list || []);
                  }
                }

                if (reRes.total > this.myRecord.length) {
                  this.zhanji.allLoaded = false;
                } else {
                  this.zhanji.allLoaded = true;
                }

                if (isRefresh) {
                  this.$refs.loadmore && this.$refs.loadmore.onTopLoaded();
                } else {
                  this.$refs.loadmore && this.$refs.loadmore.onBottomLoaded();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMyRecord(_x) {
        return _getMyRecord.apply(this, arguments);
      }

      return getMyRecord;
    }(),
    getMsg: function () {
      var _getMsg = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(isRefresh) {
        var reRes;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (isRefresh) {
                  this.jilu.pageIndex = 0;
                } else {
                  this.jilu.pageIndex++;
                }

                _context2.next = 3;
                return service.getMsg({
                  pageIndex: this.jilu.pageIndex,
                  pageSize: this.jilu.pageSize
                });

              case 3:
                reRes = _context2.sent;

                if (reRes.ret === 0) {
                  if (isRefresh) {
                    this.msgList = reRes.data && reRes.data.flowlist || [];
                  } else {
                    this.msgList = this.msgList.concat(reRes.data.flowlist);
                  }
                }

                if (reRes.data && reRes.data.total > this.msgList.length) {
                  this.jilu.allLoaded = false;
                } else {
                  this.jilu.allLoaded = true;
                }

                if (isRefresh) {
                  this.$refs.loadmore && this.$refs.loadmore.onTopLoaded();
                } else {
                  this.$refs.loadmore && this.$refs.loadmore.onBottomLoaded();
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMsg(_x2) {
        return _getMsg.apply(this, arguments);
      }

      return getMsg;
    }(),
    getIcon: function getIcon(type) {
      try {
        return this.setting[['普通蛋', 'yoo蛋', '小捣蛋', 'yoo小捣蛋'][type]] || 'https://puui.qpic.cn/vupload/0/20190124_1548327492713_9gq36wxm2od.png/0';
      } catch (e) {
        return 'https://puui.qpic.cn/vupload/0/20190124_1548327492713_9gq36wxm2od.png/0';
      }
    }
  },
  filters: {
    date: function date(v) {
      return moment(v * 1000).format('MM月DD日 HH:mm');
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (this.isLogin) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              this.vuid = cookie.get('vuserid');
              this.getMyRecord();

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  settingKey: '福蛋记录',
  setting: {
    蛋碎: '//puui.qpic.cn/vupload/0/20181211_1544517228910_lb8gojti1hc.png/0',
    普通蛋: 'https://puui.qpic.cn/vupload/0/20190124_1548327492713_9gq36wxm2od.png/0',
    yoo蛋: 'https://puui.qpic.cn/vupload/0/20190124_1548327492714_wyskfsmcjr.png/0',
    小捣蛋: 'https://puui.qpic.cn/vupload/0/20190124_1548327492715_nxhnm246arc.png/0',
    yoo小捣蛋: 'https://puui.qpic.cn/vupload/0/20190124_1548327492715_z39c51ebuec.png/0'
  }
};